<app-preloader *ngIf="clientsService.isLoading()"></app-preloader>
<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <h1>@if(formStep() === STEP_ENUM.STEP_EXISTING_CLIENT){Actualizar cliente} @else {Nuevo cliente}</h1>

  <div class="formCliente">
    <form [formGroup]="formCustomer">
      <div class="wrapperG2">
        <div [ngClass]="{ controlWrapper: !hasOriginalClient, wrapper: hasOriginalClient }">
          @if(!hasOriginalClient) {
          <label for="clientRfc">RFC <span class="required">*</span></label>
          <input type="text" formControlName="rfc" id="clientRfc" (blur)="changeRfc($event)" />
          <span class="error rfc" [style.opacity]="rfcErrorMessages() ? 1 : 0">{{ rfcErrorMessages() }}</span>
          } @else {
          <div class="readonly">
            <label for="clientRfc">RFC</label>
            <span class="value">
              {{ originalClient()?.rfc }}
            </span>
          </div>
          }
        </div>
        @if(formStep() !== STEP_ENUM.STEP_RFC_SEARCH) {
        <div class="wrapper">
          <div class="readonly">
            <label for="clientPersonType">Tipo de persona</label>
            <span class="value">
              {{ clientsService.getPersonType(formPersonType) }}
            </span>
          </div>
        </div>
        } @if(formStep() !== STEP_ENUM.STEP_RFC_SEARCH) {
        <!-- Si es persona física -->
        @if (isNaturalPerson()) {
        <!-- Definir si es solo lectura o no -->
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientLastName">Apellido paterno</label>
          <span class="value">
            {{ originalClient()?.lastName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientLastName">Apellido paterno <span class="required">*</span></label>
          <input type="text" formControlName="lastName" id="clientLastName" />
        </div>
        } @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientMothersLastName">Apellido materno</label>
          <span class="value">
            {{ originalClient()?.mothersLastName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientMothersLastName">Apellido materno <span class="required">*</span></label>
          <input type="text" formControlName="mothersLastName" id="clientMothersLastName" />
        </div>
        } @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientName">Nombre</label>
          <span class="value">
            {{ originalClient()?.firstName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientName">Nombre <span class="required">*</span></label>
          <input type="text" formControlName="firstName" id="clientName" />
        </div>
        } } @else if(isLegalPerson()) {
        <!-- Si es persona moral -->
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientNameLegal">Nombre</label>
          <span class="value">
            {{ originalClient()?.customerName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientNameLegal">Nombre <span class="required">*</span></label>
          <input type="text" formControlName="customerName" id="clientNameLegal" />
        </div>
        } }
        <!-- Correo editable (opt-in vía [allowEditEmail]) -->
        @if(showEmailField()) {
        <div class="controlWrapper">
          <label for="clientEmailEditable">Correo electrónico</label>
          <input type="text" formControlName="email" id="clientEmailEditable" />
          <span class="error" [style.opacity]="emailErrorMessage() ? 1 : 0">{{ emailErrorMessage() }}</span>
        </div>
        }
        } @if(viewAceptedCheck()){
        <div class="controlWrapper">
          <label class="checkboxWrapper" for="acceptedErrors">
            <input type="checkbox" id="acceptedErrors" formControlName="acceptedErrors" />
            <span class="checkmark"></span>
            <span class="description">Acepto que el RFC ingresado es correcto</span>
          </label>
        </div>
        }
      </div>
      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button type="submit" class="primary" (click)="save()" [disabled]="isDisabledForm()">
            {{ saveButtonText() }}
          </button>
          @if(formStep() !== STEP_ENUM.STEP_NEW_READONLY_CLIENT){
          <button type="button" class="secondary" (click)="cancelModal()">Cancelar</button>
          }
        </div>
      </div>
    </form>
  </div>
</div>
